<!-- =========================================================================================
  File Name: CustomerDebtListFormSidebar.vue
  Description: Add New Data - Sidebar component
========================================================================================== -->
<i18n src="@/locales/modules/CustomerTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			setDialogHide =>
				handleCloseDialog(() => {
					initValues();
					setDialogHide();
				}, isFormDirty)
		"
		class="custom-dialog todo-list-form-sidebar"
		:visible.sync="isSidebarActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">{{ $t("Division") }} {{ $t("Customer") }}</h4>
			<p class="text-black font-medium" v-if="employee">{{ employee.name }}</p>
		</div>
		<perfect-scrollbar ref="vueScrollBar" class="scroll-area--data-list" :settings="settings">
			<request-steps :value="stepsData" :activeId="activeStepId" @onClick="handleSetActiveStep" :disabledIds="disabledIds" />
			<div class="px-6">
				<div v-show="activeStepId === 1">
					<h3 class="font-bold mb-4 text-base">DANH SÁCH KHÁCH HÀNG</h3>
					<vs-row v-for="cus in customers" :key="cus.id" class="flex w-full mb-2">
						<vs-col class="flex flex-1">
							<vs-checkbox v-model="customerIds" :vs-value="cus.id"></vs-checkbox>
							<p class="text-base text-black">{{ cus.name }}</p>
						</vs-col>
					</vs-row>
					<CbsPagination class="mt-3" :total="totalPages" v-model="currentPage" />
				</div>
				<div v-show="activeStepId === 2">
					<!-- Division -->
					<div v-if="divisionCheck">
						<label for class="vs-input--label">{{ $t("SetPermission") }}:</label>
						<vs-row class="flex w-full mb-2">
							<vs-col class="flex-1"></vs-col>
							<vs-col class="flex flex-1">
								<vs-checkbox v-model="checkViewAll"></vs-checkbox>
								<p class="text-base text-black">{{ $t("View") }}</p>
							</vs-col>
							<vs-col class="flex flex-1">
								<vs-checkbox v-model="checkUpdateAll"></vs-checkbox>
								<p class="text-base text-black">{{ $t("Update") }}</p>
							</vs-col>
						</vs-row>
						<vs-divider class="mt-0 pt-0" />
						<vs-row class="flex mb-4" v-for="(division, name) in dataDivision" :key="`division${name}`">
							<vs-col class="flex-1">
								<p class="text-base text-black">{{ division.display }}</p>
							</vs-col>
							<vs-col class="flex-1"> <vs-checkbox v-model="divisionCheck[division.name]['view']"></vs-checkbox> </vs-col>
							<vs-col class="flex-1">
								<vs-checkbox v-model="divisionCheck[division.name]['update']"></vs-checkbox>
							</vs-col>
						</vs-row>
						<!--  -->
					</div>
				</div>
			</div>
		</perfect-scrollbar>

		<div class="flex justify-center flex-wrap items-center" slot="footer">
			<vs-button v-if="activeStepId === 1" :disabled="!!disabledIds.length > 0" class="w-full sm:w-1/3 font-bold" @click.stop="nextStep">{{ $t("Actions.Next") }}</vs-button>

			<vs-button v-else class="w-full sm:w-1/3 font-bold" @click.stop="submitData(true)">{{ $t("Actions.Complete") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import customerGql from "@/http/requests/card/customer_gql";
import { Steps, Step } from "element-ui";
import RequestSteps from "@/components/cbs-request/RequestSteps";
import moduleCustomer from "@/store/customer/moduleCustomer";
import { mapGetters } from "vuex";

export default {
	name: "EmployeeDivisionCustomer",
	provide() {
		return { parentValidator: this.$validator };
	},
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		employee: {
			type: Object,
			default: () => {}
		}
	},
	components: {
		vSelect,
		"el-steps": Steps,
		"el-step": Step,
		RequestSteps
	},
	data() {
		return {
			isFormDirty: false,
			currentPage: 1,
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			stepsData: [
				{ id: 1, name: `${this.$t("Actions.Choose")} ${this.$t("Customer").toLowerCase()}`, status: this.$constant.REQUEST_STATUSES.WAITING },
				{ id: 2, name: `${this.$t("Actions.Choose")} ${this.$t("SetPermission").toLowerCase()}`, status: null }
			],
			activeStepId: 1,
			divisionCheck: null,
			checkViewAll: true,
			checkUpdateAll: true,
			objects: null,
			customerIds: []
		};
	},
	watch: {
		isSidebarActive(val) {
			if (!val) return;

			this.initValues();
		},
		data: function(newVal, oldVal) {
			if (_.isEmpty(newVal) || newVal !== oldVal) {
				this.$nextTick(() => {
					if (this.$refs.vueScrollBar) {
						this.$refs.vueScrollBar.$el.scrollTop = 0;
					}
				});
			}
		},
		computedFormData: {
			handler: function(newVal) {
				console.log(JSON.stringify(newVal));
				console.log(JSON.stringify(this.initFormData));
				this.isFormDirty = JSON.stringify(newVal) !== JSON.stringify(this.initFormData);
			},
			deep: true
		},
		currentPage() {
			this.customerIds = [];
			this.getListCustomers();
		},
		checkViewAll(val) {
			_.mapKeys(this.divisionCheck, (value, key) => {
				this.divisionCheck[key]["view"] = val;
			});
		},
		checkUpdateAll(val) {
			_.mapKeys(this.divisionCheck, (value, key) => {
				this.divisionCheck[key]["update"] = val;
			});
		},
		disabledIds() {
			if (this.disabledIds.length === 0) {
				this.stepsData[0].status = this.$constant.REQUEST_STATUSES.APPROVED;
				this.stepsData[1].status = this.$constant.REQUEST_STATUSES.WAITING;
			} else {
				this.stepsData = [
					{ id: 1, name: `${this.$t("Actions.Choose")} ${this.$t("Customer").toLowerCase()}`, status: this.$constant.REQUEST_STATUSES.WAITING },
					{ id: 2, name: `${this.$t("Actions.Choose")} ${this.$t("SetPermission").toLowerCase()}`, status: null }
				];
			}
		}
	},

	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar", false);
				}
			}
		},
		computedFormData() {
			return {};
		},
		dataDivision() {
			return this.$store.state.customerManagement.acccessableFields;
		},
		...mapGetters({
			getParsedCustomers: "customerManagement/getParsedCustomers"
		}),
		customers() {
			return this.getParsedCustomers || [];
		},
		totalPages() {
			return Math.ceil(this.$store.state.customerManagement.total / this.$store.state.customerManagement.limitPerPage);
		},
		disabledIds() {
			return this.customerIds.length === 0 ? [2] : [];
		}
	},
	methods: {
		initValues() {
			this.isFormDirty = false;

			this.activeStepId = 1;
			this.checkViewAll = true;
			this.checkUpdateAll = true;
			this.stepsData = [
				{ id: 1, name: `${this.$t("Actions.Choose")} ${this.$t("Customer").toLowerCase()}`, status: this.$constant.REQUEST_STATUSES.WAITING },
				{ id: 2, name: `${this.$t("Actions.Choose")} ${this.$t("SetPermission").toLowerCase()}`, status: null }
			];
			this.objects = null;
			this.customerIds = [];
			const acccessableFields = this.$store.state.customerManagement.acccessableFields;
			if (acccessableFields && acccessableFields.length > 0) {
				this.divisionCheck = {};
				acccessableFields.map(field => {
					this.divisionCheck[field.name] = {
						view: true,
						update: true
					};
				});
			}
			this.setInitFormData();
			this.$validator.reset();
		},
		setInitFormData() {
			this.$nextTick(() => {
				this.initFormData = {};
			});
		},
		handleCreateOrUpdateSuccess(isCloseForm) {
			if (isCloseForm) {
				this.$emit("closeSidebar");
			}
			this.initValues();
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: `${this.$t("SetPermission")} ${this.$t("Successful").toLowerCase()} `
				}
			});
		},
		async handleCreateOrUpdateCustomerDebt(dataObj, isCloseForm) {
			try {
				this.$vs.loading();
				try {
					await customerGql.customerMultipleUpdatePermissions(dataObj);
				} catch (error) {
					console.error("customerMultipleUpdatePermissions", error);
				}

				this.handleCreateOrUpdateSuccess(isCloseForm);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData(isCloseForm = false) {
			this.$validator.validateAll().then(result => {
				if (result) {
					try {
						const content = this.divisionCheck;
						const dataObj = {
							customer_ids: this.customerIds,
							content: JSON.stringify(content),
							objects: [{ id: this.employee.id, type: "Employee" }]
						};
						this.handleCreateOrUpdateCustomerDebt(dataObj, isCloseForm);
					} catch (error) {
						console.error(error);
					}
				}
			});
		},
		handleSetActiveStep(item) {
			this.activeStepId = item.id;
		},
		nextStep() {
			this.stepsData[0].status = this.$constant.REQUEST_STATUSES.APPROVED;
			this.stepsData[1].status = this.$constant.REQUEST_STATUSES.WAITING;
			this.activeStepId = 2;
		},
		async getCustomerAcccessableFields() {
			await this.$store.dispatch("customerManagement/getCustomerAcccessableFields");
			const acccessableFields = this.$store.state.customerManagement.acccessableFields;
			if (acccessableFields && acccessableFields.length > 0) {
				this.divisionCheck = {};
				acccessableFields.map(field => {
					this.divisionCheck[field.name] = {
						view: true,
						update: true
					};
				});
			}
		},
		async getListCustomers(isRefetch = false) {
			try {
				this.$vs.loading();
				// const filter = this.$route.params.filter || {};
				const queryOptions = {
					limit: 10,
					page: this.currentPage,
					can_update_accessables: true
				};
				if (isRefetch) {
					queryOptions.fetchPolicy = "no-cache";
				}

				if (this.searchText) {
					queryOptions.search = this.searchText;
				}

				// Fetch customers
				try {
					await this.$store.dispatch("customerManagement/fetchCustomersManagement", queryOptions);
				} catch (error) {
					console.error(error);
				}
				// if (this.$refs.table && this.searchText) {
				// 	this.$refs.table.currentx = 1;
				// }
				// this.$store.commit("customerManagement/UPDATE_CUSTOMERS_FILTER", filter);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		}
	},
	created() {
		this.$store.registerModule("customerManagement", moduleCustomer);
		this.getListCustomers();

		this.getCustomerAcccessableFields();
	},
	beforeDestroy() {
		this.$store.unregisterModule("customerManagement");
	}
};
</script>
<style lang="scss" scoped></style>
